module.exports = __webpack_public_path__ + "static/media/receipt.208b5c66.svg";